import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactDom from "react-dom";
import { Checkbox } from "semantic-ui-react";

const getElementType = () => document.activeElement.type;

/**
 * This is a checkbox that puts "focus" on an input inside the Checkbox component
 * (http://react.semantic-ui.com/modules/checkbox)
 */
export default class FocusCheckbox extends Component {
  componentDidMount() {
    const { checked } = this.props;

    if (checked) {
      ReactDom.findDOMNode(this)
        .querySelector("input")
        .focus();
    }
  }

  componentDidUpdate() {
    const { checked } = this.props;

    // If the active ele is text or textarea we do not want to steal focus
    if (checked && ["text", "textarea"].indexOf(getElementType()) === -1) {
      ReactDom.findDOMNode(this)
        .querySelector("input")
        .focus();
    }
  }

  render() {
    return <Checkbox {...this.props} />;
  }
}

FocusCheckbox.propTypes = {
  checked: PropTypes.bool,
};
